<template>
  <div class="video-wrap">
    <div
      class="flvvideo-title"
    >
      {{ cameraName }}
      <span v-if="viewMode === 'static'" @click="closeVideo"></span>
    </div>
    <video
      class="video"
      :id="'flvVideo' + currentIndex"
      muted
      autoplay
      controls
      ref="player"
      width="100%"
      height="100%"
      @play="play"
      @pause="stop"
    ></video>
    <div class="video-statusbar" v-if="loadStatus === true">
      {{ loadMsg }}
    </div>
    <!-- <div v-else class="errow">
      此视频资源暂无法播放，请查看后再试
    </div> -->
  </div>
</template>

<script>
import flvjs from "flv.js";

export default {
  name: "flvPlayer",
  props: {
    viewMode: {
      default: "static",
      type: String,
    },
    currentIndex: {
      type: Number,
    },
    loadMsg: {
      type: String,
    },
    loadStatus: {
      type: Boolean,
    },
    item: {
      type: Object,
    },
    url: {
      type: String,
    },
    cameraId: {
      type: String,
    },
    cameraName: {
      type: String,
    },
  },
  data() {
    return {
      aspect: "100%",
      fluent: true,
      autoplay: true,
      showErrow: false,
      player: null,
      isShowClose:false
    };
  },
  // watch: {
  //   url() {
  //     this.onUrlChanged();
  //   },
  // },
  mounted() {
    this.$nextTick(() => {
      if (this.url && this.url != "") {
        this.createFlv(this.url);
      }
    });
  },
  beforeUpdate() {
    console.log("beforeUpdate");
    this.destoryVideo();
    this.$nextTick(() => {
      if (this.url && this.url != "") {
        this.createFlv(this.url);
      }
    });
  },
  beforeDestroy() {
    this.destoryVideo();
    console.log("beforeDestroy");
    // this.$nextTick(() => {
    //   if (this.url && this.url != "") {
    //     this.createFlv(this.url);
    //   }
    // });
  },
  destroyed() {},
  methods: {
    onUrlChanged() {
      this.$nextTick(() => {
        if (this.url && this.url != "") {
          this.createFlv(this.url);
        }
      });
    },
    destoryVideo() {
      console.log("destroyvideo");
      if (this.player) {
        this.player.pause();
        this.player.unload();
        this.player.detachMediaElement();
        this.player.destroy();
        this.player = null;
      }
    },
    closeVideo() {
      this.$emit("destoryVideo", this.currentIndex);
      this.destoryVideo();
    },
    mouseOver(){
      this.isShowClose = true;
    },
    mouseLeave(){
      this.isShowClose = false;
    },
    createFlv(url) {
      console.log("url", url);
      // 准备监控设备流地址
      // const url = encodeURIComponent(uri); // 宇视
      // 创建一个flvjs实例
      if (flvjs.isSupported()) {
        this.player = flvjs.createPlayer(
          {
            type: "flv",
            // isLive: true,
            url: url,
          },
          {
            enableWorker: false, //不启用分离线程
            enableStashBuffer: false, //关闭IO隐藏缓冲区
            fixAudioTimestampGap: false,
            lazyLoad: false,
          }
        );

        this.player.on("error", (e) => {
          console.log(e);
        });

        // 将实例挂载到video元素上面
        this.player.attachMediaElement(this.$refs.player);

        try {
          // 开始运行加载 只要流地址正常 就可以在h5页面中播放出画面了
          this.player.load();
          this.player.play();
          // let playPromise = this.player.play();
          // if (playPromise !== undefined) {
          //   playPromise
          //     .then(() => {
          //       this.player.play();
          //     })
          //     .catch(() => {});
          // }

          this.$emit("play", {});
        } catch (error) {
          console.log(error);
        }
      }
    },
    stop() {
      this.player.pause();
      this.$emit("stop", {});
    },
    play() {
      this.player.play();
      this.$emit("play", {});
    },
    fullScreen() {
      let element = document.getElementById("flvVideo" + this.currentIndex);
      this.Screen(element);
    },
    // 全屏
    Screen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.oRequestFullscreen) {
        element.oRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      } else {
        var docHtml = document.documentElement;
        var docBody = document.body;
        var videobox = document.getElementById("flvVideo" + this.currentIndex);
        var cssText = "width:100%;height:100%;overflow:hidden;";
        docHtml.style.cssText = cssText;
        docBody.style.cssText = cssText;
        videobox.style.cssText = cssText + ";" + "margin:0px;padding:0px;";
        document.IsFullScreen = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.player-wrapper {
  width: 100%;
  height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 100%;
  padding-bottom: 0 !important;
}
.video-wrap {
  position: relative;
  .video {
    width: 100%;
    height: 100%;
  }
}
.video-wrap,
.video-player {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
}
.flvvideo-title {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  text-align: left;
  width: 100%;
  height: 50/1080 * 100vh;
  padding: 0 20/100 * 1rem;
  font-size: 16/100 * 1rem;
  line-height: 50/1080 * 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  padding-left: 1rem;
  span {
    position: absolute;
    right: 10px;
    top: 0;
    width: 30/1080 * 100vh;
    height: 50/1080 * 100vh;
    background: url("../../../public/theme/default/img/video/close.png")
      no-repeat center center;
    background-size: 20/1080 * 100vh 20/1080 * 100vh;
    cursor: pointer;
  }
}
.video-statusbar {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 2;
  text-align: left;
  width: 100%;
  height: 50/1080 * 100vh;
  padding: 0 20/100 * 1rem;
  font-size: 16/100 * 1rem;
  line-height: 50/1080 * 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  padding-left: 1rem;
}
.errow {
  width: 100%;
  height: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  background: #000;
  color: #fff;
  font-size: 14px;
  text-align: center;
}
.vjs-custom-skin > .video-js {
  height: 100%;
}
.vjs-custom-skin > .video-js .vjs-big-play-button {
  height: 1.4em !important;
  line-height: 1.4em !important;
}
</style>